module.exports = __webpack_public_path__ + "img/eldiario.1faaa6ad.svg";